import {IAutoOrderOrderingSettings} from './ao-ordering-settings.interface';

//#region DEFAULT _DEFAULT_OPEN_ORDER_SETTINGS
export const _DEFAULT_AUTO_ORDER_ORDERING_SETTINGS: Readonly<IAutoOrderOrderingSettings> = {
  body: '',
  ccRecipients: '',
  contactName: '',
  contactNumber: '',
  orderNumber: 'AUTO',
  subject: '',
} as const;
//#endregion